<template>
  <section class="review">
    <slot name="info" v-bind="{ rating, maxRating, date }">
      <div class="review__info">
        <div class="summary">{{ summary }}</div>
        <div :class="{ ' flex middle': rating > 0 && maxRating > 0 }">
          <Rating v-if="rating" :max="maxRating" :score="rating" />
        </div>
        <slot name="message" v-bind="{ finalMessage, buttonText }">
          <div :class="{ 'display-none': !message }">
            <p class="review__message">{{ finalMessage }}</p>
            <SfButton
              :class="{ 'display-none': !showButton }"
              class="sf-button--text sf-review__read-more"
              @click="toggleMessage"
            >
              {{ buttonText }}
            </SfButton>
          </div>
        </slot>
        <div class="info-content flex justify middle">
          <div class="info-bottom flex middle">
            <slot name="author" v-bind="{ author }">
              <div class="review__author">
                <span>Bewertet von</span>
                {{ author }}
              </div>
            </slot>
            <div class="review__date">
              <span>am</span>
              {{ convertDate(date) }}
            </div>
          </div>
        </div>
      </div>
    </slot>
  </section>
</template>
<script>
import Rating from "~/components/Palmers/Product/Rating/Rating.vue";
import SfIcon from "~/node_modules/@storefront-ui/vue/src/components/atoms/SfIcon/SfIcon.vue";
import SfButton from "~/node_modules/@storefront-ui/vue/src/components/atoms/SfButton/SfButton.vue";
export default {
  name: "Reviews",
  components: {
    Rating,
    SfIcon,
    SfButton,
  },
  props: {
    author: {
      type: String,
      default: "",
    },
    summary: {
      type: String,
      default: "",
    },
    date: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
    rating: {
      type: [Number, String, Boolean],
      default: false,
    },
    maxRating: {
      type: [Number, String],
      default: 5,
    },
    charLimit: {
      type: [Number, String],
      default: 250,
    },
    readMoreText: {
      type: String,
      default: "Read more",
    },
    hideFullText: {
      type: String,
      default: "Read less",
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    showButton() {
      return this.message.length > this.charLimit;
    },
    buttonText() {
      let buttonText = this.readMoreText;
      if (this.isOpen) {
        buttonText = this.hideFullText;
      }
      return buttonText;
    },
    finalMessage() {
      return this.message.length > this.charLimit && !this.isOpen
        ? this.message.slice(0, this.charLimit) + "..."
        : this.message;
    },
  },
  methods: {
    convertDate(date) {
      if(!date) return '';

      let d = new Date(date);
      let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
      let mo = new Intl.DateTimeFormat('en', { month: 'numeric' }).format(d);
      let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
      return `${da}/${mo}/${ye}`;
    },
    toggleMessage() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>
